import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { SigningVerifyingModel } from '../model/signing-verifying.model';

export type SigningState =
  | { state: 'idle' }
  | {
      state: 'verified';
      data: SigningVerifyingModel;
    };

const initialState: SigningState = { state: 'idle' };

@Injectable()
export class SigningStore extends ComponentStore<SigningState> {
  readonly isVerified$ = this.select(s => s.state === 'verified');
  readonly verifiedState$ = this.select(s => (s.state === 'verified' ? s : null));
  readonly setVerifiedState = this.updater<SigningVerifyingModel>((_, data) => ({ state: 'verified', data }));

  constructor() {
    console.log('Init SigningStoreStore');
    super(initialState);
  }
}
